import { render, staticRenderFns } from "./DashboardGestaoErros.vue?vue&type=template&id=669d3208&scoped=true&"
import script from "./DashboardGestaoErros.vue?vue&type=script&lang=js&"
export * from "./DashboardGestaoErros.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGestaoErros.vue?vue&type=style&index=0&id=669d3208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d3208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow})
